// extracted by mini-css-extract-plugin
export default {"flexMiddle":"checkout_flexMiddle__MKgQj"};